import { classNames } from "../../helpers";
import typography from "../../helpers/typography";
import Footer from "../../components/Footer";
import EventsSlideShow from "../Event/EventsSlideShow";

import {
  cciLogo,
  FacebookIcon,
  headerCollage,
  InstagramIcon,
  TwitterIcon,
  YoutubeIcon,
} from "../../helpers/images";
import {
  DocumentMagnifyingGlassIcon,
  UserPlusIcon,
  DocumentTextIcon,
  ShareIcon,
} from '@heroicons/react/24/outline';

const Header = () => {
  return (
    <header className="2xl:container 2xl:mx-auto text-center md:text-left p-8 sm:p-14 md:p-10 bg-artfulRed-200 text-black flex-none md:flex md:items-center">
      <div className="md:p-4">
        <h1 className={classNames(typography.sizes.h1, "font-poppins")}>
          Connecting you to happening events.
        </h1>
        <p className="my-8 text-xl lg:text-2xl font-light">
          Create and share personalized DP based on events or campaigns in
          Celebration Church International
        </p>

        {/* TODO - replace this with "View Demo" */}
        {/*<div className="buttons mb-8 flex justify-around md:justify-start">*/}
        {/*  <Button type="secondary" text="Get Started" to="/login" icon="right-arrow" />*/}
        {/*</div>*/}
      </div>

      <div className="md:p-4 lg:p-8">
        <img className="w-full" src={headerCollage} alt="CCI Header" />
      </div>
    </header>
  );
};

const EventBanners = () => {
  return (
    <section className="2xl:container 2xl:mx-auto py-10 md:py-20 text-zinc-800">
      <h2
        className={classNames(
          typography.sizes.h3,
          "text-center font-poppins font-medium mb-10"
        )}>
        Recent Events
      </h2>

      <div className="my-8">
        <EventsSlideShow />
      </div>
    </section>
  );
};

const HowItWorks = () => {
  const steps = [
    {
      id: 1,
      icon: DocumentMagnifyingGlassIcon,
      title: "Find An Event",
      message: "Explore our recent events or find an event"
    },
    {
      id: 2,
      icon: UserPlusIcon,
      title: "Upload Picture",
      message: "Upload your picture in the shape (square or circle)",
    },
    {
      id: 3,
      icon: DocumentTextIcon,
      title: "Enter Name",
      message: "Optionally enter your full name if required"
    },
    {
      id: 4,
      icon: ShareIcon,
      title: "Share",
      message: "Download and share the generated DP",
    },
  ];

  return (
    <section className="2xl:container 2xl:mx-auto p-6 md:p-16 bg-greyBg text-zinc-800">
      <h2
        className={classNames(
          typography.sizes.h3,
          "text-center font-poppins font-medium mb-8"
        )}
      >
        How It Works
      </h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-8 p-8">
        {steps.map((step) => (
          <div
            key={step.id}
            className="flex flex-col items-center text-center mb-10 md:mb-2 px-4"
          >
            <step.icon className="h-10 w-auto mb-3 text-artfulRed" />
            <h5 className="text-lg my-2">{step.title}</h5>
            <p className="text-sm">{step.message}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

const SocialMediaLinks = () => {
  const socials = [
    {
      id: "yt",
      name: "Youtube",
      icon: YoutubeIcon,
      link: "https://www.youtube.com/c/CelebrationChurchNG",
    },
    {
      id: "fb",
      name: "Facebook",
      icon: FacebookIcon,
      link: "https://web.facebook.com/CelebrationChurchIntl",
    },
    {
      id: "ig",
      name: "Instagram",
      icon: InstagramIcon,
      link: "https://www.instagram.com/cci_global/",
    },
    {
      id: "tw",
      name: "Twitter",
      icon: TwitterIcon,
      link: "https://twitter.com/cci__global",
    },
  ];

  return (
    <section className="2xl:container 2xl:mx-auto p-6 py-10">
      <h2 className="text-center mb-5">
        Follow us on our social media to see what we are up to
      </h2>
      <div className="flex justify-center">
        {socials.map((item) => (
          <div
            key={item.id}
            className="mx-4 transition-all duration-300 ease-in-out transform hover:-translate-y-1"
          >
            <a href={item.link} target="_blank" rel="noreferrer">
              <item.icon />
            </a>
          </div>
        ))}
      </div>
    </section>
  );
};

const LogoStrip = () => {
  return (
    <section className="2xl:container 2xl:mx-auto pb-6 something">
      <hr />
      <div className="flex justify-center mt-5">
        <img
          alt="CCI Logo"
          className="w-30 h-16 block flex-none self-center"
          src={cciLogo}
        />
      </div>
    </section>
  );
};

const Home = () => {
  return (
    <>
      <Header />
      <EventBanners />
      <HowItWorks />
      <SocialMediaLinks />
      <LogoStrip />
      <Footer />
    </>
  );
};

export default Home;
